'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AlertSuccess = require('./components/AlertSuccess.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AlertSuccess).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/alerts/lib/components/success/index.js
// module id = 364
// module chunks = 0 1 4